import { httpPost } from './request/index'

// 留言反馈列表
export function getList (data) {
  return httpPost('/messageBoard/getList', data)
}

// 留言反馈列表
export function save (data) {
  return httpPost('/messageBoard/save', data)
}
// 删除留言反馈列表
export function del (data) {
  return httpPost('/messageBoard/del', data)
}
